// enum object
export const EligibleFor = Object.freeze({
	Refund: 'eligibleForRefund',
	RefundAssist: 'eligibleForRefundAssist',
	Containerlabel: 'eligibleForContainerLabel',
	Manifest: 'eligibleForManifest',
	InsuranceClaim: 'eligibleForInsuranceClaim',
});

// eligible for options
export default Object.freeze([
	{
		label: 'Refund',
		value: EligibleFor.Refund,
		dataqa: 'eligible-for-refund',
	},
	{
		label: 'Refund Assist',
		value: EligibleFor.RefundAssist,
		dataqa: 'eligible-for-refund-assist',
	},
	{
		label: 'Container Label',
		value: EligibleFor.Containerlabel,
		dataqa: 'eligible-for-container-label',
	},
	{
		label: 'SCAN Form',
		value: EligibleFor.Manifest,
		dataqa: 'eligible-for-manifest',
	},
	{
		label: 'Insurance Claim',
		value: EligibleFor.InsuranceClaim,
		dataqa: 'eligible-for-insurance-claim',
	},
]);

export const EligibleForParams = Object.freeze({
	Refund: 'refund',
	RefundAssist: 'refundassist',
	Pickup: 'pickup',
	Containerlabel: 'containerlabel',
	Manifest: 'manifest',
	InsuranceClaim: 'fileclaim',
});
